
import {
    FaGithub,
    FaLinkedin,
    FaUniversity,
    FaMicrosoft,
    FaOrcid,
    FaPython,
    FaJava,
    FaJs,
    FaReact,
    FaDatabase,
    FaDocker,
    FaGitAlt,
    FaTools,
    FaLinux,
    FaTerminal,
    FaRobot,
    FaCheckCircle,
    FaServer,
    FaFacebookF,
    FaInstagram,
    FaSoundcloud,
    FaPinterest,
} from "react-icons/fa";
import { FaCuttlefish, FaMicrochip } from 'react-icons/fa6';
import { GrMailOption } from "react-icons/gr";
import { MdPersonOutline, MdWork, MdRouter } from "react-icons/md";
import { MdArchitecture } from "react-icons/md";

import { GiBrain } from 'react-icons/gi';
import { IoMdAnalytics } from 'react-icons/io';
import profilePhoto from '../images/mehrab_photo_1.jpeg';

export const portfolioData = {
    name: "Mehrab Mahdian",
    profilePhoto: profilePhoto,
    pronunciation: "/ˈmɛhrɑb mɑːdɪˈɑn/",
    role: "Electronics & Intelligent Systems Engineer",
    email: "mehrabmahdian@outlook.com",
    workEmail: "mehrab.mahdian@taltech.ee",
    location: "Tallinn, Estonia",
    summary: "",
    about: [
        "Mehrab Mahdian is an Electronics & Intelligent Systems Engineer with a strong background at the intersection of electronics, software development, and data-driven methods. His work focuses on the design and development of intelligent systems that integrate hardware, computation, and modern programming tools.",

        "With formal training in electronics engineering and hands-on experience in software and research projects, Mehrab works across the full stack of technical systems—from electronic and embedded components to data processing, automation, and intelligent analysis. His interests include intelligent electronic systems, embedded and cyber-physical systems, and the application of AI-inspired methods to real-world engineering problems.",

        "Mehrab has experience in academic and research-oriented environments, contributing to technical projects that require both analytical rigor and practical implementation. He values clarity, reproducibility, and system-level understanding, and focuses on bridging the gap between physical systems and intelligent computation."
    ],

    skills: [
        { name: "Python (Expert)", icon: <FaPython /> },
        { name: "Artificial Intelligence", icon: <GiBrain /> },
        { name: "Computer Vision", icon: <FaRobot /> },
        { name: "Explainable AI", icon: <FaRobot /> },
        { name: "Scientific Computing", icon: <IoMdAnalytics /> },

        { name: "Embedded Systems", icon: <FaMicrochip /> },
        { name: "Edge AI & TinyML", icon: <MdRouter /> },

        { name: "Full-Stack System Development", icon: <MdArchitecture /> },
        { name: "Backend Development & APIs", icon: <FaServer /> },
        { name: "Databases (SQL & NoSQL)", icon: <FaDatabase /> },

        { name: "Linux", icon: <FaLinux /> },
        { name: "Docker", icon: <FaDocker /> },
        { name: "Git", icon: <FaGitAlt /> },
        { name: "Shell Scripting", icon: <FaTerminal /> },

        { name: "C / C++", icon: <FaCuttlefish /> }
    ],



    experience: [
        {
            role: "Early Stage Researcher / PhD Student",
            company: "Tallinn University of Technology (TalTech)",
            period: "Oct 2024 - Present",
            description: "Working at the Research Laboratory for Cognitronics on the Cogni-E-spin project, focusing on data-driven modeling, optimization, and control of electrospinning processes. Developing software-supported and AI-inspired methods for automated quality monitoring and control of nanofiber production.",
            icon: <MdWork />
        },
        {
            role: "Artificial Intelligence Engineer",
            company: "Creo Group (Creo.hu)",
            period: "2024",
            description: "Developed AI models for out-of-distribution detection, real-time object detection, and recommender systems for adaptive examination platforms.",
            icon: <MdWork />
        },
    ],
    education: [
        {
            degree: "PhD, Information Technology and Communication",
            institution: "Tallinn University of Technology",
            year: "2024 - Present",
            status: "In Progress"
        },
        {
            degree: "MSc, Electrical Engineering (Embedded Systems & Smart City)",
            institution: "Budapest University of Technology and Economics",
            year: "2021 - 2024",
            status: "Summa Cum Laude (Excellent with Highest Honors)"
        },
        {
            degree: "BSc, Technology of Electronics",
            institution: "Technical and Vocational University (TVU)",
            year: "2018 - 2020",
            status: "Graduated"
        },
        {
            degree: "ASc, General Electronics",
            institution: "Technical and Vocational University (TVU)",
            year: "2016 - 2018",
            status: "Graduated"
        }
    ],
    publications: [
            {
            title: "A surrogate-based inverse design framework for targeted diameter control of electrospun nanofibers",
            journal: "Scientific Reports (Nature)",
            year: "2026",
            link: "https://doi.org/10.1038/s41598-026-40692-3"
        },
        {
            title: "Cogni-e-SpinDB 1.0: Open Dataset of Electrospinning Parameter Configurations and Resultant Nanofiber Morphologies",
            journal: "Scientific Data (Nature)",
            year: "2026",
            link: "https://doi.org/10.1038/s41597-025-06520-5"
        }

    ],
    honors: [
        { title: "Summa Cum Laude", year: "2024", awarder: "BME Hungary" },
        { title: "Stipendium Hungaricum Scholarship", year: "2021", awarder: "Tempus Public Foundation" },
    ],
    memberships: [
        { role: "Chapter Secretary", organization: "IEEE Estonia Section Joint Chapter", year: "2025 - Present" },
        { role: "PhD Student Representative", organization: "TalTech Department Council", year: "2025 - Present" },
        { role: "Student Member", organization: "IEEE", year: "2025 - Present" },

    ],
    academicService: [
        {
            role: "Thesis Reviewer",
            organization: "Budapest University of Technology and Economics (BME)",
            period: "Jun 2024 - Present",
            description: "Reviewer for BSc and MSc theses covering topics such as TinyML, reinforcement learning, generative AI, recommender systems, and applied machine learning.",
            icon: <FaCheckCircle />
        },
        {
            role: "Supervision",
            organization: "Tallinn University of Technology (TalTech)",
            period: "2024 - Present",
            description: "Supervised two undergraduate interns on data collection and analysis within the Cogni-E-spin project.",
            icon: <FaCheckCircle />
        }
    ],


    projects: [
        {
            title: "Electrospinning Data Platform",
            description: "An open-source, crowdsourcing platform for standardized electrospinning datasets. Developed as part of PhD research to promote open science.",
            link: "https://electrospinning-data.org",
            githubRepo: "https://github.com/taltechloc/electrospinning-data.org",
            tags: ["React", "Open Science", "Data Sharing", "Electrospinning"]
        },
        {
            title: "Cogni-e-Spin DB 1.0",
            description: "An open dataset of 809 experimental records on electrospinning parameter configurations and nanofiber morphologies, curated for ML and research benchmarking.",
            link: "https://zenodo.org/records/16731638",
            tags: ["Dataset", "Zenodo", "Open Data", "Machine Learning"]
        },
        {
            title: "py_pidx",
            description: "An advanced Python library for PID control, featuring gain scheduling, anti-windup, and derivative filtering for robust, real-world applications.",
            link: "https://github.com/mehrabmahdian/py_pidx",
            tags: ["Python", "Control Systems", "PID", "Open Source"]
        }
    ],
    socialLinks: [
        { href: "https://www.linkedin.com/in/mehrab-mahdian/", icon: <FaLinkedin />, label: "LinkedIn" },
        { href: "https://github.com/mehrabmahdian", icon: <FaGithub />, label: "GitHub" },
        { href: "https://www.etis.ee/CV/Mehrab_Mahdian/eng/", icon: <MdPersonOutline />, label: "ETIS" },
        { href: "https://taltech.ee/kontaktid/kognitroonika-teaduslabor/mehrab-mahdian/", icon: <FaUniversity />, label: "TalTech" },
        { href: "mailto:mehrab.mahdian@taltech.ee", icon: <GrMailOption />, label: "Work Email" },
        { href: "mailto:mehrabmahdian@outlook.com", icon: <FaMicrosoft />, label: "Outlook Email" },
        { href: "https://orcid.org/0000-0001-8384-1435", icon: <FaOrcid />, label: "ORCID" },
        { href: "https://www.facebook.com/mehrab.mahdian/", icon: <FaFacebookF />, label: "Facebook" },
        { href: "https://www.instagram.com/mahdian.mehrab/", icon: <FaInstagram />, label: "Instagram" },
    ]
};

